import { render, staticRenderFns } from "./TeamOrganogram.vue?vue&type=template&id=71f84951&scoped=true&"
import script from "./TeamOrganogram.vue?vue&type=script&lang=js&"
export * from "./TeamOrganogram.vue?vue&type=script&lang=js&"
import style0 from "./TeamOrganogram.vue?vue&type=style&index=0&id=71f84951&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f84951",
  null
  
)

export default component.exports